var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatyouget3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#a3d4ff",
    r: 256
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-7.423-.316-14.772-.935-22.034l-148.09-148.089-69.517 66.174 49.905 49.468-228.945-80.225 126.802 126.802-5.329 5.945-70.457-70.457-63.529 219.948 103.461 103.461c16.368 3.284 33.3 5.007 50.634 5.007 141.385 0 256-114.615 256-256z",
    fill: "#65b1fc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346.566 329.278h63.529v74.254h-63.529z",
    fill: "#fa5d0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.012 277.376h63.529v126.156h-63.529z",
    fill: "#fa5d0f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fe8205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.459 227.505h63.529v176.027h-63.529z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.905 183.584h63.529v219.948h-63.529z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m423.651 172.549-28.384 9.71 13.515 39.508-281.98-127.798-12.384 27.325 282.389 127.983-41.322 14.136 9.71 28.385 88.853-30.396z",
    fill: "#3871d6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m327.555 70.267c-26.51 0-48 21.49-48 48s21.49 48 48 48c.161 0 .319-.011.48-.012l10-48.925-10-47.05c-.16-.003-.319-.013-.48-.013z",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m327.555 70.267c26.51 0 48 21.49 48 48s-21.49 48-48 48z",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m327.555 88.328c-16.535 0-29.939 13.404-29.939 29.939s13.404 29.939 29.939 29.939c.161 0 .32-.01.48-.012l10-30.816-10-29.037c-.16-.004-.319-.013-.48-.013z",
    fill: "#fdba12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m327.555 88.328c16.535 0 29.939 13.404 29.939 29.939s-13.404 29.939-29.939 29.939z",
    fill: "#ff9500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatyouget3);
export default __webpack_public_path__ + "static/media/whatyouget3.5e4aa5df3a5c39db2b220a236b2eaa5f.svg";
export { ForwardRef as ReactComponent };